import { LinkedFilesParams, ViewFilesParams } from '@lk/api'
import { UploadFileParams } from '@lk/api/linkedFiles/models/uploadFile-prams.model'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { actions as LKModalActions } from '../../features/shared/LKModal'
import { ThunkApi } from '../index.d'
import { translate } from 'loankeeper-common/helpers'
export const translateLKMessage = (name: string): string => translate(`LKMESSAGE-${name}`)

export const editFile = createAsyncThunk<any, LinkedFilesParams, ThunkApi>(
  '[LINKED_FILES/FILES ACTION] EDIT',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.linkedFiles.fileAction('edit', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const deleteFile = createAsyncThunk<any, LinkedFilesParams, ThunkApi>(
  '[LINKED_FILES/FILES ACTION] DELETE',
  async ({ ...params }, { extra, rejectWithValue, dispatch }) => {
    const result = await extra.api.linkedFiles.fileAction('delete', params)

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(translateLKMessage(result.error.message)))
    return rejectWithValue(result.error.message)
  },
)

export const viewFile = createAsyncThunk<any, ViewFilesParams, ThunkApi>(
  '[LINKED_FILES] VIEW',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.linkedFiles.view(params)
    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const uploadFile = createAsyncThunk<any, UploadFileParams, ThunkApi>(
  '[LINKED_FILES] UPLOAD',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.linkedFiles.upload(params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const toggleFileVisa = createAsyncThunk<any, LinkedFilesParams, ThunkApi>(
  '[LINKED_FILES] TOGGLE_VISA',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.linkedFiles.toggleFileVisaAction('visa', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const toggleDeleteFileVisa = createAsyncThunk<any, LinkedFilesParams, ThunkApi>(
  '[LINKED_FILES] TOGGLE_DELETE_VISA',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.linkedFiles.toggleFileVisaAction('delete_visa', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
